<template>
  <b-card title="Relatório DRE" class="border border-primary">
    <b-row>
      <b-col cols="12" md="3">
        <b-form-group label="Data inicial" label-for="Data inicial">
          <MonthYearPickerInput
            v-model="$v.form.startDate.$model"
            :state="validateState('startDate')"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Data final" label-for="Data final">
          <MonthYearPickerInput
            v-model="$v.form.endDate.$model"
            :state="validateState('endDate')"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3" class="d-flex align-items-center">
        <b-button variant="primary" @click="fetchData"
          >Gerar relatório</b-button
        >
      </b-col>
    </b-row>
    <div v-if="isLoading" class="text-center">
      <b-spinner variant="primary"></b-spinner>
      <p>Carregando...</p>
    </div>
    <div v-else-if="!isLoading && report">
      <RelatorioDRECard title="Receitas" :report="report.revenues" />
      <RelatorioDRECard title="Despesas" :report="report.expenses" />
    </div>
  </b-card>
</template>

<script>
import MonthYearPickerInput from "@/components/Form/MonthYearPickerInput.vue";
import moment from "moment";
import { validationMixin } from "vuelidate";
import RelatorioDRECard from "./componentes/RelatorioDRECard.vue";
import {
  MAX_RANGE_IN_MONTHS,
  RelatorioDREDataRequired,
} from "./RelatorioDreData";

export default {
  name: "app-relatorio-dre",
  data() {
    return {
      isLoading: false,
      form: {
        startDate: moment().subtract(3, "months").format("yyyy-MM"),
        endDate: moment().format("yyyy-MM"),
      },
      report: null,
    };
  },
  components: {
    RelatorioDRECard,
    MonthYearPickerInput,
  },
  mixins: [validationMixin],
  validations: {
    form: RelatorioDREDataRequired,
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async fetchData() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        if (!this.$v.maxMonthDiff) {
          return this.$toast.error(
            `O período entre a data inicial e data final deve ser menor ou igual a ${MAX_RANGE_IN_MONTHS} meses`
          );
        }
        return this.$toast.error(
          "Verifique todos os campos obrigatórios do formulário!"
        );
      }

      this.isLoading = true;
      this.report = null;
      try {
        const { startDate, endDate } = this.form;
        const response = await this.$http.post("/financeiro/dre", {
          startDate: moment(`${startDate}-01`).format("yyyy-MM-DD"),
          endDate: moment(`${endDate}-01`).endOf("month").format("yyyy-MM-DD"),
        });
        this.report = {
          expenses: response.data.find((e) => e.type == 1),
          revenues: response.data.find((e) => e.type == 2),
        };
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados do relatório DRE.");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
